import { create } from "zustand";

export interface Presence {
  x: number;
  y: number;
  /** Zeitstempel des letzten Updates – alte Werte können wir verwerfen. */
  ts: number;
}

interface PresenceState {
  positions: Record<string, Presence>;
  setPosition: (playerId: string, x: number, y: number) => void;
  remove: (playerId: string) => void;
  clear: () => void;
}

/**
 * Live-Positionen aller Spieler. Werden im Spiel mit hoher Frequenz vom
 * Client geschrieben (eigener Spieler) bzw. aus serverseitigen
 * `game:event`-Updates abgeleitet (Mitspieler). Andere Module (z. B. der
 * Voice-Chat-Hook) können daraus die Entfernung berechnen und die
 * Lautstärke pro Peer dynamisch anpassen.
 */
export const usePresenceStore = create<PresenceState>((set) => ({
  positions: {},
  setPosition: (playerId, x, y) =>
    set((state) => ({
      positions: {
        ...state.positions,
        [playerId]: { x, y, ts: performance.now() },
      },
    })),
  remove: (playerId) =>
    set((state) => {
      if (!state.positions[playerId]) return state;
      const next = { ...state.positions };
      delete next[playerId];
      return { positions: next };
    }),
  clear: () => set({ positions: {} }),
}));
